import DefaultCell from "application/components/DefaultCell";
import RowAction from "application/components/RowAction";

import { taskManagementSystem } from "globals/configuration/taskManagementSystem";
import formControl from "globals/form-control";



const Attributes = {
formSize: "md",
enableAddButton: true,
settingsMode: false,
enableAdvanceSearch: true,

modes: taskManagementSystem.map((item) => {
return {
id: item.key,
name: item.name,
iconName: item.icon,
url: item.url,
description: item.description,
disabled: item.disabled,
productionReady: item.productionReady,
};
}),
};

const operationURLS = {
create: "taskStatus/create",
update: "taskStatus/update",
list: "taskStatus/list",
delete: "taskStatus/delete",
};

const getColumns = (onDelete, onEdit) => {
return [
{
    Header: "Task Status",
    accessor: "taskStatus",
    displayInList: true,
    allowInForm: true,
    allowFilter: true,
    dataType: "string",
    width: 12,
    downloadReports: false,
    controlType: "select",
    options: {
      keyField: "id",
      keyDescription: "description",
      values: [
          { id: "New", description: "New" },
          {id:"Yet to start",description: "Yet to start"},
          { id: "In Progress", description: "In Progress" },
          { id: "Closed", description: "Closed" },
      ],
    },

    validation: formControl.string().required("Required").nullable(),
    Cell: ({ value, row }) => <DefaultCell value={value} row={row} />,
  },
{
Header: "createdBy",
accessor: "createdBy",
displayInList: false,
allowInForm: false,
allowFilter: false,
dataType: "string",
width: 6,
Cell: ({ value }) => <DefaultCell value={value} />,
},
{
Header: "createdOn",
accessor: "createdOn",
displayInList: true,
allowInForm: false,
allowFilter: false,
dataType: "string",
controlType: "dateTime",
width: 6,
Cell: ({ value }) => <DefaultCell value={value} />,
},
{
Header: "updatedBy",
accessor: "updatedBy",
displayInList: false,
allowInForm: false,
allowFilter: false,
dataType: "string",
width: 6,
Cell: ({ value }) => <DefaultCell value={value} />,
}, {
Header: "updatedOn",
accessor: "updatedOn",
displayInList: false,
allowInForm: false,
allowFilter: false,
dataType: "string",
controlType: "dateTime",
width: 6,
Cell: ({ value }) => <DefaultCell value={value} />,
},

{
Header: "Action",
accessor: "id",
displayInList: true,
allowInForm: false,
Cell: ({ row, value }) => (
<RowAction
row={row}
value={value}
//onEdit={onEdit}
onDelete={onDelete}
/>
),
},
];
};

export { getColumns, Attributes, operationURLS };